export default __webpack_public_path__ + "static/media/tete9.d3ab236e.png";